"use client";

import * as React from "react";
import { Search } from "lucide-react";
import { CartIcon } from "@/components/shop/CartIcon";
import { ProductsSearch, useWPQueryForSearch } from "@/components/shop/ProductsSearch";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
const categories = ["Todos", "Trefilado", "Tuberia", "Solido", "Polineria", "Perfiles", "Láminas", "Placas", "Herrajes"];
function CatalogConsumer() {
  const {
    posts,
    loading,
    error,
    refetch
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {[...Array(8)].map((_, i) => <div key={i} data-index={i} className="h-96 rounded-lg bg-card animate-pulse" />)}
      </div>;
  }
  if (error) {
    return <div className="text-sm text-muted-foreground font-default">
        Error al cargar productos.{" "}
        <Button onClick={() => refetch()} variant="link" className="p-0 h-auto underline text-primary">
          Reintentar
        </Button>
      </div>;
  }
  if (posts.length === 0) {
    return <p className="text-muted-foreground font-default text-lg">
        No hay productos disponibles en este momento.
      </p>;
  }
  return <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {posts.map((post, i) => {
      const image = {
        src: post.customFields?.imagen || post.featuredImage,
        srcset: "",
        sizes: ""
      };
      return <article data-index={i} key={post.id} className="group rounded-lg bg-card overflow-hidden transition-all duration-300 hover:-translate-y-1.5 hover:ring-1 hover:ring-primary/40 hover:shadow-lg flex flex-col h-full">
            <Link to={post.link || "#"} className="block">
              <div className="aspect-square overflow-hidden bg-muted">
                {image.src ? <img src={image.src} data-wvc-srcset={image.srcset} data-wvc-sizes={image.sizes} alt={post.customFields?.nombre || post.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" /> : <div className="h-full w-full bg-muted" />}
              </div>
            </Link>

            <div className="p-5 space-y-3 flex flex-col flex-grow">
              {post.customFields?.product_category && <span className="inline-block font-mono text-[11px] uppercase tracking-widest text-secondary">
                  ESTRUCTURALES
                </span>}

              <Link to={post.link || "#"} className="block">
                <h3 className="font-default font-bold text-[22px] leading-tight text-foreground">
                  {post.customFields?.nombre || post.title}
                </h3>
              </Link>

              {post.customFields?.descripcion && <div className="text-sm text-muted-foreground line-clamp-3 whitespace-pre-wrap font-default flex-grow">
                  {post.customFields.descripcion}
                </div>}

              <div className="pt-4">
                <Link to={post.link || "#"}>
                  <Button className="w-full bg-primary text-primary-foreground rounded-md font-default font-medium">
                    Ver Detalles
                  </Button>
                </Link>
              </div>
            </div>
          </article>;
    })}
    </div>;
}
export default function SubProductsGrid() {
  const [search, setSearch] = React.useState("");
  const [activeCategory, setActiveCategory] = React.useState("Todos");
  const [searchQuery] = useWPQueryForSearch(search);
  const wp_query = React.useMemo(() => {
    if (search.trim()) {
      return searchQuery;
    }
    const baseArgs = {
      post_type: "subproducto",
      per_page: 12,
      orderby: "date",
      order: "desc"
    };
    if (activeCategory === "Todos") {
      return new WP_Query(baseArgs);
    }
    return new WP_Query({
      ...baseArgs,
      meta_query: [{
        key: "product_category",
        value: activeCategory.toUpperCase(),
        compare: "="
      }]
    });
  }, [search, searchQuery, activeCategory]);
  return;
}